var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18 9.66699H6L12 16.3337L18 9.66699Z","fill":"currentColor"}));
}

ArrowDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
